import React from 'react';
import PageContainer from 'containers/PageContainer';
import OverviewView from 'views/OverviewView';
import moment from 'moment';
import { findNextAndPrevPack, mapPack } from 'helpers/subscriptionHelpers';
import useDisableReasons from 'hooks/useDisableReasons';

const OverviewContainer = () => {
  const { topupsDisableReason, changeUsageDisableReason } = useDisableReasons();

  return (
    <PageContainer
      logoRef="/overview"
      requiresAccount
      requiresLogin
      displayNavBar
      requiresSubscription
      render={(subscription, account, store) => {
        const today = moment().format('YYYY-MM-DD');
        const { nextPack, previousPack, nextDeliverablePack } = (subscription
          && findNextAndPrevPack(subscription.packs, today)) || {};
        const mappedNextDeliverablePack = nextDeliverablePack
          && mapPack(nextDeliverablePack, subscription, account, store);

        const hideChangeUsage = !mappedNextDeliverablePack
          || mappedNextDeliverablePack.product.packSize.usage === 'Occasional'
          || (
            mappedNextDeliverablePack.product.packSize.usage === 'Monthly'
            && !subscription.recommendedSolution);

        return (
          <OverviewView
            account={account}
            nextPaymentAmount={subscription.next_payment_amount}
            nextPack={mapPack(nextPack, subscription, account, store)}
            previousPack={mapPack(previousPack, subscription, account, store)}
            nextDeliverablePack={mappedNextDeliverablePack}
            topupsDisabledReason={topupsDisableReason}
            changeUsageDisableReason={changeUsageDisableReason}
            packageDetailsPath="/package"
            canChangeAddress={!subscription.isNonLensMail && !account.isMinor}
            hideChangeUsage={hideChangeUsage}
          />
        );
      }}
    />
  );
};

OverviewContainer.displayName = 'OverviewContainer';

export default OverviewContainer;
